import api from 'api'
import { objectsToArray } from 'functions/utilities'

export function concatNames(contacts = {}, options = {}){
  const array = objectsToArray(contacts)

  const contactOne = array[0]
  const contactTwo = array[1]

  // Single Contact
  if (array.length === 1){
    if (options.firstNameOnly) return contactOne.first_name
    return contactOne.full_name
  }

  // Two Contacts
  if (contactOne && contactTwo){
    // Same Last Names
    if (!options.firstNameOnly && contactOne.last_name === contactTwo.last_name){
      return `${contactOne.first_name} & ${contactTwo.first_name} ${contactOne.last_name}`
    }

    // Different Last Names
    if (options.firstNameOnly) return `${contactOne.first_name} & ${contactTwo.first_name}`
    return `${contactOne.full_name} & ${contactTwo.full_name}`
  }

  return ''
}

export function searchContacts(string, requestOptions, options = {}){
  const { url } = options || {}
  const requestUrl = url || '/agency/contacts/search.json'

  const mergedOptions = {
    string,
    limit: 10,
    ...requestOptions,
  }

  return api(requestUrl, mergedOptions)
    .then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok){
        return Promise.reject(json)
      }

      return { success: true, result: json }
    })
    .catch(err => ({ success: false, result: err }))
}

export default concatNames
